import BookSessionDetails from '../../../guidanceSessions/components/BookSessionDetails';

export default function BookSessionDetailsScreen() {
    return <BookSessionDetails />;
}
